import { Box } from "@mui/material";
import { createContext, useEffect, useState } from "react";
import { ItemType } from "../../../../client/menuClient";
import { ENABLE_ITEM_BG, DISABLE_ITEM_BG } from "./DASHBOARD_ITEM_BG";
import { ItemEnableDisable } from "./ItemEnableDisable";
import { UpdateItem } from "./UpdateItem";

export const DashboardItemContext = createContext<{
  setItemBackgroundColor: (color: string) => void;
}>({
  setItemBackgroundColor: () => {},
});

export const DashboardItem = ({
  item,
  currency,
  isItemWiseTaxEnabled,
  removeItemFromCategory,
}: DashboardItemProps) => {
  const [itemBackgroundColor, setItemBackgroundColor] = useState<string>(
    getItemRowBg(item.isEnabled)
  );

  useEffect(() => {
    setItemBackgroundColor(getItemRowBg(item.isEnabled));
  }, [item.isEnabled]);

  return (
    <DashboardItemContext.Provider value={{ setItemBackgroundColor }}>
      <Box
        display="flex"
        alignItems="center"
        width="100%"
        py={0.75}
        px={0.5}
        bgcolor={itemBackgroundColor}
        borderBottom="1px solid rgba(0,0,0,0.06)"
        data-testid="menu-item"
      >
        <ItemEnableDisable item={item} />
        <UpdateItem
          item={item}
          currency={currency}
          isItemWiseTaxEnabled={isItemWiseTaxEnabled}
          removeItemFromCategory={removeItemFromCategory}
        />
      </Box>
    </DashboardItemContext.Provider>
  );
};

export const getItemRowBg = (isEnabled: boolean) => {
  return isEnabled ? ENABLE_ITEM_BG : DISABLE_ITEM_BG;
};

type DashboardItemProps = {
  item: ItemType;
  currency: string;
  removeItemFromCategory: (itemId: number) => void;
  isItemWiseTaxEnabled: boolean;
};
